const EARTH_RADIUS_KM = 6371;

function validPoint(point) {
  if (!point || point.lat === null || point.lng === null || point.lat === "" || point.lng === "") return false;
  const lat = Number(point.lat);
  const lng = Number(point.lng);
  return Number.isFinite(lat) && Number.isFinite(lng) && Math.abs(lat) <= 90 && Math.abs(lng) <= 180;
}

export function haversineKm(a, b) {
  if (!validPoint(a) || !validPoint(b)) return Number.POSITIVE_INFINITY;
  const radians = (degrees) => (Number(degrees) * Math.PI) / 180;
  const deltaLat = radians(Number(b.lat) - Number(a.lat));
  const deltaLng = radians(Number(b.lng) - Number(a.lng));
  const lat1 = radians(a.lat);
  const lat2 = radians(b.lat);
  const value = Math.sin(deltaLat / 2) ** 2 + Math.cos(lat1) * Math.cos(lat2) * Math.sin(deltaLng / 2) ** 2;
  return 2 * EARTH_RADIUS_KM * Math.asin(Math.sqrt(value));
}

export function nearestStore(origin, stores = []) {
  if (!validPoint(origin)) return null;
  let result = null;
  let distance = Number.POSITIVE_INFINITY;
  for (const store of stores) {
    if (store.enabled === false || !validPoint(store)) continue;
    const candidateDistance = haversineKm(origin, store);
    if (candidateDistance < distance) {
      distance = candidateDistance;
      result = { ...store, distanceKm: candidateDistance };
    }
  }
  return result;
}

export function buildStockistUrl(base, query) {
  const separator = String(base).includes("?") ? "&" : "?";
  return `${base}${separator}stockist-query=${encodeURIComponent(String(query).trim())}`;
}

function setResult(region, store) {
  region.replaceChildren();
  if (!store) {
    region.textContent = "Aucun magasin avec coordonnées vérifiées n’a été trouvé. Utilisez la recherche par ville ci-dessous.";
    return;
  }
  const title = document.createElement("strong");
  title.textContent = `${store.name} — environ ${Math.round(store.distanceKm)} km à vol d’oiseau`;
  const address = document.createElement("p");
  address.textContent = store.address;
  const links = document.createElement("p");
  const page = document.createElement("a");
  page.href = store.page_url;
  page.textContent = "Voir la page du magasin";
  links.append(page);
  if (store.maps_url) {
    links.append(" · ");
    const maps = document.createElement("a");
    maps.href = store.maps_url;
    maps.textContent = "Itinéraire";
    maps.rel = "noopener";
    links.append(maps);
  }
  region.append(title, address, links);
}

export function initStoreFinders(root = document) {
  root.querySelectorAll("[data-ms-store-finder]").forEach((finder) => {
    const button = finder.querySelector("[data-ms-locate]");
    const region = finder.querySelector("[data-ms-location-result]");
    const dataNode = finder.querySelector("[data-ms-stores-json]");
    if (!button || !region || !dataNode) return;
    let stores = [];
    try { stores = JSON.parse(dataNode.textContent); } catch { region.textContent = "La liste des magasins est temporairement indisponible."; }
    button.addEventListener("click", () => {
      if (!navigator.geolocation) {
        region.textContent = "La géolocalisation n’est pas disponible. Recherchez votre ville ou votre code postal ci-dessous.";
        return;
      }
      button.disabled = true;
      region.textContent = "Recherche du magasin le plus proche…";
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setResult(region, nearestStore({ lat: position.coords.latitude, lng: position.coords.longitude }, stores));
          button.disabled = false;
        },
        () => {
          region.textContent = "Votre position n’a pas été partagée. Vous pouvez rechercher une ville ou un code postal ci-dessous.";
          button.disabled = false;
          finder.querySelector("input[name='stockist-query']")?.focus();
        },
        { enableHighAccuracy: false, timeout: 10_000, maximumAge: 300_000 },
      );
    });
  });
}

if (typeof document !== "undefined") {
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", () => initStoreFinders());
  else initStoreFinders();
}

